/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Export_All_ButtonInputs */



/**
* | output |
* | --- |
* | "Export All" |
*
* @param {Preset_Manager_Export_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_all_button = /** @type {((inputs?: Preset_Manager_Export_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout exporter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт всех")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar tudo")
	return /** @type {LocalizedString} */ ("Export All")
});